import InitSwal from '../components/Swal'

// Global flag to prevent multiple dialogs
let isDialogShowing = false
let currentDialogPromise = null

/**
 * Shows a well-designed version update dialog using SweetAlert2
 * @param {string} newVersion - The new version number
 * @returns {Promise<boolean>} - Returns true if user clicks update, false if later
 */
export const showVersionUpdateDialog = (newVersion = '') => {
  // If dialog is already showing, return the existing promise
  if (isDialogShowing && currentDialogPromise) {
    return currentDialogPromise
  }

  isDialogShowing = true
  const message = `A new version <b>${(newVersion ?? '')}</b> of the application is available. Click "<b>Update Now</b>" to refresh and update.`

  currentDialogPromise = InitSwal.fire({
    title: 'New Version Available',
    html: message,
    icon: 'info',
    showCancelButton: false,
    confirmButtonText: 'Update Now',
    customClass: {
      confirmButton: 'btn btn-primary ms-1'
    },
    buttonsStyling: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    reverseButtons: true,
    focusConfirm: true
  }).then((result) => {
    // Reset flags when dialog is closed
    isDialogShowing = false
    currentDialogPromise = null
    return result.isConfirmed
  })

  return currentDialogPromise
}
